<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="map">
<h1>Map</h1>
<div class="figure" style="text-align: center;">
<img alt="" src="media/file0.jpg" style="width:5.72656in;height:3.65024in"/>
<p class="caption">Map Description automatically generated</p>
</div>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?54502784